import { render, staticRenderFns } from "./ModalModelosCargaRemuneracao.vue?vue&type=template&id=5db5b929"
import script from "./ModalModelosCargaRemuneracao.vue?vue&type=script&lang=ts"
export * from "./ModalModelosCargaRemuneracao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports